import script from "./MichiganView.vue?vue&type=script&setup=true&lang=js"
export * from "./MichiganView.vue?vue&type=script&setup=true&lang=js"

import "./MichiganView.vue?vue&type=style&index=0&id=5e4ac48e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4ac48e"]])

export default __exports__